import React from "react";
import './Cards.scss'
import { Card, Slot, Button, Tooltip, ButtonGroup, ButtonIcon, CardV2 } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import './Cards.scss'

function TaxonomyCard({ card }) {
    const navigate = useNavigate();


    /* istanbul ignore next */
	return (
		<>
			<CardV2
				className="ph-course-card"
				cardBody={{
					isDark: false,
					slot: <div
									style={{
										minHeight: "410px",
										width: "100%",
										height: "100%",
										display: "flex",
										flexDirection: "column",
										// justifyContent: "space-between",
										fontFamily: 'Inter'
									}}
								>

									<div style={{width: '100%', height: '160px',  
												position: 'relative', overflow: 'hidden', 
												borderRadius: "8px 8px 0px 0px",
												background: "hsla(215, 95%, 74%, 1)", display: "flex", justifyContent: "center", alignItems:"center"}}>
										<img 
											alt="img" 
											src ={card.image} 
											style={{
												// width: '128px',
												// height: '128px',
												objectFit: 'cover',
												display: 'block',
												borderRadius: '8px 8px 0 0'
										}} />
									</div>
									<div className="card-title-container">
										
										<div className="card-description" style={{display: "flex", margin: "0px", padding: "24px 24px 0px 24px"}}>
											
											<div style={{color: "#4B4B4B", fontSize: "14px", lineHeight: "20px"}}>
												<div className="card-title" style={{color: "#2d2d2d", lineHeight: "28px", fontSize: "22px", whiteSpace: "normal", fontWeight: 700}}>{card.courseName}</div>
												<div style={{ paddingTop:"16px" }}>
													

													{card.buttons.map((item) => (
                                                        <Button
															className="taxonomy-button"
															iconTrailing={"open_in_new"}
															size="medium"
															style={{color:item.url==null?"#b1b1b1":"#034895"}}
															text={item.name}
															variant="tertiary"
															disabled={item.url==null}
															onClick={function clickButton() {
																if(item.url) {
																	window.open(item.url, "_blank")
																}
															}}
														/>
                                                	))}

												</div>
											</div>
										</div>
									</div>
								</div>,
					
					type: 'slot',
					
				}}
				maxScrollHeight="90px"
				state="interactive"
				style={{}}
				type="basic"
				viewport="desktop"
			/>
			
		</>
	);
}

export default TaxonomyCard;
